/**
 * P5-02: LoadingScreen —— React replacement for #loadingContainer.
 *
 * Mirrors the old index.html markup:
 * - animated loader gif
 * - progress bar driven by the module loader
 * - info text driven by the module loader
 *
 * The screen is shown on mount and unmounts itself when the loading bridge
 * fires "loaded".
 */
import { useEffect, useState } from "react";
import {
  setLoadingLoadedListener,
  setLoadingProgressListener,
} from "../../bridge/loading";

export default function LoadingScreen() {
  const [loaded, setLoaded] = useState(false);
  const [progress, setProgress] = useState(0);
  const [message, setMessage] = useState("Setting up game engine...");

  useEffect(() => {
    setLoadingProgressListener((p: number, m: string) => {
      setProgress(p);
      setMessage(m);
    });
    setLoadingLoadedListener(() => setLoaded(true));
    return () => {
      setLoadingProgressListener(null);
      setLoadingLoadedListener(null);
    };
  }, []);

  if (loaded) {
    return null;
  }

  return (
    <div className="content">
      <span style={{ fontSize: "18px" }}>
        <img
          className="loader"
          width={16}
          height={16}
          src="res/ajax-loader.gif"
          alt=""
        />
        &nbsp;Loading...
        <br />
      </span>
      <br />
      <progress value={progress} max={100} />
      <div>{message}</div>
    </div>
  );
}
